import { LooseObject } from '../interface';

/**
 * Checks if the two objects are deeply inequal
 */
export const isObjectDeeplyChanged = (newObj?: LooseObject, oldObj?: LooseObject) =>
    JSON.stringify(newObj) !== JSON.stringify(oldObj);
